import {PERSIAN_RED} from '../../globalVariables/GlobalVariables';

interface ExCircleProps {
    color?: string;
    backgroundColor?: string;
    width?: number;
    height?: number;
}

const ExCircle = ({
    color = 'white',
    backgroundColor = PERSIAN_RED,
    width = 17,
    height = 17
}: ExCircleProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 17 17"
        fill="none"
    >
        <g clipPath="url(#clip0_12538_2264)">
            <path
                d="M14.5097 14.5104C17.8292 11.191 17.8292 5.80905 14.5097 2.48959C11.1903 -0.829864 5.80838 -0.829864 2.48892 2.48959C-0.830533 5.80905 -0.830533 11.191 2.48892 14.5104C5.80838 17.8299 11.1903 17.8299 14.5097 14.5104Z"
                fill={backgroundColor}
            />
            <path
                d="M11.5 5.5L5.5 11.5M5.5 5.5L11.5 11.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_12538_2264">
                <rect width="17" height="17" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default ExCircle;
